@if (control) {
  @if (message !== undefined) {
    @if (skipValidation === false) {
      <div [class]="'invalid-feedback invalid-feedback--' + errorStyle">
        {{ message }}
      </div>
    }
  } @else {
    @if (skipValidation === false || hasCustomValidationMessage) {
      <div [class]="'invalid-feedback invalid-feedback--' + errorStyle">
        <portal-validation-errors
          [dirty]="control.dirty"
          [errors]="errors"
          [ignoreErrors]="ignoreErrors"
          [validationErrors]="validationErrors"
        ></portal-validation-errors>
      </div>
    }
  }
}
